import { useTranslation } from "react-i18next";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { TbCalendarCheck, TbCalendarTime } from "react-icons/tb";
import { Badge } from "reactstrap";
import { tField } from "../../utils/helpers";

function BalanceCard({data}) {
  const { t } = useTranslation('balance');

  return(
    <div className="card h-100 shadow-sm border-0">
      {/* Header Section */}
      <div className="card-header bg-primary text-white text-center py-3 border-0">
        <h5 className="mb-0 font-weight-bold">{tField(data.plan, 'name')}</h5>
      </div>

      {/* Body Section */}
      <div className="card-body p-4">
        {/* Properties Stats */}
        <div className="row text-center mb-4">
          <div className="col-6 border-end">
            <div className="p-2">
              <h3 className="text-primary mb-2 font-weight-bold">
                {data.remaining_normal_properties}
              </h3>
              <small className="text-muted d-block">{t("normal_properties")}</small>
            </div>
          </div>
          <div className="col-6">
            <div className="p-2">
              <h3 className="text-success mb-2 font-weight-bold">
                {data.remaining_premium_properties}
              </h3>
              <small className="text-muted d-block">{t("premium_properties")}</small>
            </div>
          </div>
        </div>

        {/* Divider */}
        <hr className="my-3" />

        {/* Date Information */}
        <div className="mt-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span className="text-muted d-flex align-items-center">
              <TbCalendarCheck size={18} className="me-1" />
              {t("start_date")}
            </span>
            <span className="font-weight-bold text-dark">
              {data.start_date}
            </span>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <span className="text-muted d-flex align-items-center">
              <TbCalendarTime size={18} className="me-1" />
              {t("end_date")}
            </span>
            <span className="font-weight-bold text-dark">
              {data.end_date}
            </span>
          </div>
        </div>
      </div>

      {/* Optional Footer with Status Badge */}
      <div className="card-footer bg-light border-0 text-center py-3">
        <Badge color="success" className="rounded-pill px-3 py-2 d-inline-flex align-items-center justify-content-center">
          <IoMdCheckmarkCircleOutline size={18} className="me-1" />
          {t("active")}
        </Badge>
      </div>
    </div>
  );
}

export default BalanceCard;